import React, { useState } from 'react';
import { forgotPassword } from '../services/authService';
import './ForgotPasswordModal.css';

interface ForgotPasswordModalProps {
	isOpen: boolean;
	onClose: () => void;
}

export const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = ({ isOpen, onClose }) => {
	const [username, setUsername] = useState<string>('');
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string>('');
	const [successMessage, setSuccessMessage] = useState<string>('');

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		if (!username.trim()) {
			setError('Korisničko ime je obavezno');
			return;
		}

		setError('');
		setIsLoading(true);

		try {
			await forgotPassword(username);

			setSuccessMessage('Zahtev za resetovanje lozinke je poslat. Ukoliko korisničko ime postoji u sistemu, primićete email sa instrukcijama.');
			setUsername('');
		} catch (err) {
			setError(err instanceof Error ? err.message : 'Greška pri slanju zahteva za resetovanje lozinke');
		} finally {
			setIsLoading(false);
		}
	};

	const handleClose = () => {
		setUsername('');
		setError('');
		setSuccessMessage('');
		onClose();
	};

	const handleInputChange = (value: string) => {
		setUsername(value);
		if (error) setError('');
		if (successMessage) setSuccessMessage('');
	};

	if (!isOpen) return null;

	return (
		<div className='modal-overlay'>
			<div className='modal-content forgot-password-modal'>
				<div className='modal-header'>
					<h2>Resetovanje lozinke</h2>
					<button className='close-button' onClick={handleClose} disabled={isLoading}>
						×
					</button>
				</div>

				<div className='forgot-password-content'>
					{successMessage ? (
						<div className='success-section'>
							<div className='alert alert-success'>{successMessage}</div>
							<button type='button' className='btn btn-primary' onClick={handleClose}>
								Zatvoriti
							</button>
						</div>
					) : (
						<form onSubmit={handleSubmit} className='forgot-password-form'>
							<div className='form-description'>
								<p>Unesite svoje korisničko ime da biste dobili instrukcije za resetovanje lozinke.</p>
							</div>

							{error && <div className='alert alert-error'>{error}</div>}

							<div className='form-group'>
								<label htmlFor='username'>Korisničko ime *</label>
								<input type='text' id='username' value={username} onChange={(e) => handleInputChange(e.target.value)} placeholder='Unesite korisničko ime' required disabled={isLoading} autoFocus />
							</div>

							<div className='form-actions'>
								<button type='button' className='btn btn-secondary' onClick={handleClose} disabled={isLoading}>
									Otkaži
								</button>
								<button type='submit' className='btn btn-primary' disabled={isLoading || !username.trim()}>
									{isLoading ? 'Šalje se...' : 'Pošalji zahtev'}
								</button>
							</div>
						</form>
					)}
				</div>
			</div>
		</div>
	);
};
